export default [
  {
    function: 'Coordenação do Projeto',
    team: [
      {
        name: 'Ana Emilia Figueiredo de Oliveira',
        link: 'http://lattes.cnpq.br/5767658067485112',
      },
    ],
  },
  {
    function: 'Coordenação Geral da DTED/UNA-SUS/UFMA',
    team: [
      {
        name: 'Ana Emilia Figueiredo de Oliveira',
        link: 'http://lattes.cnpq.br/5767658067485112',
      },
    ],
  },
  {
    function: 'Gestão de projetos da UNA-SUS/UFMA',
    team: [
      {
        name: 'Amanda Rocha Araújo',
        link: 'http://lattes.cnpq.br/2347649300131056',
      },
    ],
  },
  {
    function: 'Coordenação de Produção Pedagógica da UNA-SUS/UFMA',
    team: [
      {
        name: 'Paola Trindade Garcia',
        link: 'http://lattes.cnpq.br/8513290455922124',
      },
    ],
  },
  {
    function: 'Coordenação de Ofertas Educacionais da UNA-SUS/UFMA',
    team: [
      {
        name: 'Elza Bernardes Monier',
        link: 'http://lattes.cnpq.br/3034477335930315',
      },
    ],
  },
  {
    function: 'Coordenação de Tecnologia da Informação da UNA-SUS/UFMA',
    team: [
      {
        name: 'Mário Antônio Meireles Teixeira',
        link: 'http://lattes.cnpq.br/9943003955628885',
      },
    ],
  },
  {
    function: 'Coordenação de Comunicação da UNA-SUS/UFMA',
    team: [
      {
        name: 'José Henrique Coutinho Pinheiro',
        link: 'http://lattes.cnpq.br/8493739280209743',
      },
    ],
  },

  {
    function: 'Professora-autora',
    team: [
      {
        name: 'Ankilma do Nascimento Andrade Feitosa',
        link: 'http://lattes.cnpq.br/2482812431372557',
      },
    ],
  },

  {
    function: 'Validadores Técnicos MS',
    team: [
      {
        title:
          'Coordenação-Geral de Ações Estratégica, Inovação e Avaliação da Educação em Saúde (CGIED/DEGES/SGTES/MS)',
      },
      {
        name: 'Bethânia Ramos Meireles',
        link: 'http://lattes.cnpq.br/9367518274116068',
      },
      {
        name: 'Rosany Ferreira Rios Fonseca',
        link: 'http://lattes.cnpq.br/2030480271587281',
      },
      {
        name: 'Carolina Vaccari Simaan',
        link: 'http://lattes.cnpq.br/4711238601467961',
      },
      {
        title:
          'Coordenação-Geral de Saúde da Pessoa com Deficiência (CGSPD/DAET/SAES/MS)',
      },
      {
        name: 'Angelo Roberto Gonçalves -',
        link: 'http://lattes.cnpq.br/8512130086054911',
      },
      {
        name: 'Cicero Kaique Pereira Silva',
      },
      {
        name: 'Denise Maria Rodrigues Costa',
        link: 'http://lattes.cnpq.br/3976494747721222',
      },
      {
        name: 'Diogo do Vale de Aguiar',
        link: 'http://lattes.cnpq.br/8213134257372189',
      },
      {
        name: 'Flávia da Silva Tavares',
        link: 'http://lattes.cnpq.br/5701574543357640',
      },
      {
        title: 'Coordenação-Geral de Saúde do Trabalho (CGDEP/DAEVS/SVS/MS)',
      },

      {
        name: 'Nathalie Alves Agripino',
        link: 'http://lattes.cnpq.br/5842947310667833',
      },
      {
        title: 'Hospital das Clínicas da Faculdade de Medicina da USP',
      },
      {
        name: 'Daniel Ciampi Araújo de Andrade',
        link: 'http://lattes.cnpq.br/2865639392426834',
      },
      {
        title:
          'Coordenação Saúde Pessoa Idosa (COSAPI/ CGCIVI/ DAPES/ SAPS/ MS)',
      },
      {
        name: 'Maria Cristina Corrêa Lopes Hoffmann',
        link: 'http://lattes.cnpq.br/4810675725131338',
      },
      {
        name: 'Natália Vargas Patrocínio de Campos ',
        link: 'http://lattes.cnpq.br/9012487410864336',
      },
      {
        name: 'Wendel Rodrigo Teixeira Pimentel',
        link: 'http://lattes.cnpq.br/2983309866035774',
      },
      {
        title:
          'Coordenação de Saúde das Mulheres/ Coordenação-Geral de Ciclos da Vida (COSMU/CGCIVI/DAPES/SAPS/MS)',
      },
      {
        name: 'Anelise Trigo Cid',
        link: 'http://lattes.cnpq.br/9768699350511955',
      },
      {
        title:
          'Coordenação Geral de Atenção Hospitalar e Domiciliar (CGAHD/DAHU/SAES/MS)',
      },
      {
        name: 'Mariana Borges Dias',
        link: 'http://lattes.cnpq.br/9255538418952723',
      },
      {
        title:
          'Coordenação de Evidências e Informações Estratégicas para Gestão em Saúde, Departamento de Ciência e Tecnologia.  (COEvI/DECIT/MS)',
      },
      {
        name: 'Virginia Kagure Wachira',
        link: 'http://lattes.cnpq.br/ 2264821993200310',
      },
      {
        title: 'Coordenação-Geral de Saúde Mental, Álcool e Outras Drogas',
      },
      {
        name: 'Rafael Bernardon Ribeiro',
        link: 'http://lattes.cnpq.br/0319564285043701',
      },
      {
        name: 'Daniela Palma Araújo',
        link: 'http://lattes.cnpq.br/3111776614455487',
      },
    ],
  },

  {
    function: 'Validadoras pedagógicas',
    team: [
      {
        name: 'Lívia Anniele Sousa Lisboa',
        link: 'http://lattes.cnpq.br/3791992392780805',
      },
      {
        name: 'Deysianne Costa das Chagas',
        link: 'http://lattes.cnpq.br/7600882185941353',
      },
      {
        name: 'Izabel Cristina Vieira de Oliveira',
        link: 'http://lattes.cnpq.br/4712062438844539',
      },
    ],
  },

  {
    function: 'Revisora textual',
    team: [
      {
        name: 'Mizraim Nunes Mesquita',
        link: 'http://lattes.cnpq.br/9688410026685214'
      }
    ]
  },

  {
    function: 'Designer instrucional',
    team: [
      {
        name: 'Karoline Corrêa Trindade',
        link: 'http://lattes.cnpq.br/3710850735697577',
      },
    ],
  },

  {
    function: 'Designer Gráfico',
    team: [
      {
        name: 'Agnes Guerra',
        link: 'http://lattes.cnpq.br/7946101508917844',
      },
    ],
  },

  {
    function: 'Tecnologia da informação',
    team: [
      {
        name: 'Rayanne Maria Cunha Silveira',
        link: 'http://lattes.cnpq.br/2999561859534744',
      },
      {
        name: 'Victor Maya Nascimento Almeida',
        link: 'http://lattes.cnpq.br/0702449965826613',
      },
    ],
  },
];
